export default "__VITE_ASSET__CVbMTntC__"